[1]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker= "equilateralTriangle", text = "Hi! Welcome to a world of shapes, Multi-shaper!" },
  { speaker = "player", text = "World of shapes, where?!?... Multi-shaper - me?!?... wait... who are you?"},
  { speaker = "equilateralTriangle", text = "I'm Equila the Triangle, you're the Multi-shaper and this is the world of Shapes! In this world, we're all different shapes... but you... you are a very rare multi-shaper!" },
  { speaker = "player", text = "I am?... what does that mean?" },
  { speaker = "equilateralTriangle", text = "Well, we shapes enjoy staying in shape physically and mentally... by making moves and talking shapes! Click next and I'll show you!" }
]
outro = [
  { speaker = "equilateralTriangle", text = "Wow. That was great... and really helpful! Thank you." },
  { speaker = "player", text = "You're welcome. Now what?" },
  { speaker = "equilateralTriangle", text = "You did so well, it'd be great if you could help my friends?" },
  { speaker = "player", text = "I could do that...What do I need to do?" },
  { speaker = "equilateralTriangle", text = "Keep getting into shape by making moves and talking shapes!" },
  { speaker = "player", text = "All right!!" }
]
completionAnimation = [
  { id = "equilateralTriangle", moveTo = "background center", animation = "triangle_waving" }
]

[2]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "circle", text = "Wow! I can't believe its you!? ... I'm so excited to meet new shapes! My name is Circ the Circle!"},
  { speaker = "player", text = "Equila the Triangle said you needed help!" },
  { speaker = "circle", text = "I do!... Click next and let's get in shape!" },
]
outro = [
  { speaker = "circle", text = "Whoa... Equila said you we're good, but that was amazing! ... Say, you think you could help another friend of ours, Tang the Rectangle?" },
  { speaker = "player", text = "Sure." },
  { speaker = "circle", text = "Ok!... Click next and let's get in shape!" },
]
completionAnimation = [
  { id = "circle", moveTo = "background center", animation = "circle_waving" }
]

[3]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "circle", text = "Tang... I brought someone for you to meet!" },
  { speaker = "rectangle", text = "Oh... is it the multi-shaper all the shapes are talking about??" },
  { speaker = "circle", text = "Yes, it is!" },
  { speaker = "rectangle", text = "Honored to meet you.  I'm Tang the Rectangle... Let's get in shape!" }
]
outro = [
  { speaker = "rectangle", text = "What talents you have! Could help out Alene the Scalene Triangle too?" },
  { speaker = "player", text = "Of course..." },
]
completionAnimation = [
  { id = "rectangle", moveTo = "background center", animation = "rectangle_waving" }
]
[4]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "scaleneTriangle", text = "So you're the multi-shaper? I'm Alene the Scalene Triangle. Tang said you can help?" },
  { speaker = "player", text = "I'll do what I can?" },
  { speaker = "scaleneTriangle", text = "Awesome! Let's get into shape!" }
]
outro = [
  { speaker = "scaleneTriangle", text = "That's excellent the way you did that!..." },
  { speaker = "player", text = "Let me guess, you have a friend you'd like me to help?" },
  { speaker = "scaleneTriangle", text = "Ohh, would you? Could you? Esqua will be so happy!! Let's go!" },
]
completionAnimation = [
  { id = "scaleneTriangle", moveTo = "background center", animation = "scaleneTriangle_waving" }
]
[5]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "square", text = "Hi Multi-Shaper. I am Esque the Square. Thanks for helping me shape up?" },
  { speaker = "player", text = "Glad to..." },
]
outro = [
  { speaker = "square", text = "That's so hip! So grateful for your help." },
  { speaker = "player", text = "It's hip to be square! ... So... who's next?" },
  { speaker = "square", text = "Trappy the Trapezoid... come with me!" },
]
completionAnimation = [
  { id = "square", moveTo = "background center", animation = "square_waving" }
]
[6]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "trapezoid", text = "So excited... thank you, Multi-shaper" },
  { speaker = "player", text = "It's my pleasure" },
  { speaker = "trapezoid", text = "OK... Let's get in shape!" },
]
outro = [
  { speaker = "trapezoid", text = "That's some shaping, Multi-shaper!" },
  { speaker = "player", text = "Glad you think so. I think I'm getting better at this. It's been great helping...but, how do I get back to my world?" },
  { speaker = "trapezoid", text = "You have to go Full Circle! HA! Go see Circ the Circle!" },
]
completionAnimation = [
  { id = "trapezoid", moveTo = "background center", animation = "trapezoid_waving" }
]
[7]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" }
]
intro = [
  { speaker = "circle", text = "Hey, Multi-shaper!! How's it going?" },
  { speaker = "player", text = "It's been great, Circ. Getting in shape is great, but I need to start making my way back to my world." },
  { speaker = "circle", text = "I understand. Follow me and we'll get in shape for your journey. " },
]
outro = [
  { speaker = "circle", text = "Now that you've come full circle, haha, All things being equal... Go find Equila the Triangle to restore your equilibrium!... This will get you back to where you belong!" },
]
completionAnimation = [
  { id = "circle", moveTo = "background center", animation = "circle_waving" }
]
[8]
scene = [
  { id = "equilateralTriangle", distance = "foreground", placement = "center", color = "blue", mood = "happy" },
  { id = "circle", distance = "aboveground", placement = "right", color = "pink", mood = "happy" },
  { id = "rectangle", distance = "foreground", placement = "left", color = "blue", mood = "neutral" },
  { id = "square", distance = "foreground", placement = "right", color = "green", mood = "happy" },
  { id = "scaleneTriangle", distance = "background", placement = "center", color = "green", mood = "neutral" },
  { id = "trapezoid", distance = "midground", placement = "center", color = "pink", mood = "happy" },
]
intro = [
  { speaker = "equilateralTriangle", text = "Hey Multi-shaper! You've been busy!! I heard you are looking for a way home?" },
  { speaker = "equilateralTriangle", text = "Ok, come with me and let's shape up!" },
]
outro = [
  { speaker = "equilateralTriangle", text = "Well, your transformation is underway... (Sniffle sniffle) Its been great shaping with you!" },
  { speaker = "player", text = "Likewise... it was fun shaping up, down and all around!!!" },
  { speaker = "equilateralTriangle", text = "Goodbye, Multi-Shaper... and never forget... 'with great shapes comes great responsibilityyyyyyyyy!" },
]
completionAnimation = [
  { id = "equilateralTriangle", moveTo = "background center", animation = "triangle_waving" },
]
